export const CUSTOMER_SUBJECT_MIN = 5;
export const CUSTOMER_SUBJECT_MAX = 180;
export const CUSTOMER_DETAILS_MIN = 15;
export const CUSTOMER_DETAILS_MAX = 500_000;

export function customerTicketValidation(subject: string, details: string) {
  const subjectLength = subject.trim().length;
  const detailsLength = details.trim().length;
  const subjectValid = subjectLength >= CUSTOMER_SUBJECT_MIN && subjectLength <= CUSTOMER_SUBJECT_MAX;
  const detailsValid = detailsLength >= CUSTOMER_DETAILS_MIN && detailsLength <= CUSTOMER_DETAILS_MAX;
  return { subjectLength, detailsLength, subjectValid, detailsValid, valid: subjectValid && detailsValid };
}
